/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    CreateInvitationRequest,
    CreateInvitationResponse,
    EditInvitationRequest,
} from '../models';

export interface InvitationApiControllerCreateInvitationRequest {
    createInvitationRequest: CreateInvitationRequest;
}

export interface InvitationApiControllerEditInvitationRequest {
    invitationId: string;
    editInvitationRequest: EditInvitationRequest;
}

/**
 * 
 */
export class InvitationsApi extends runtime.BaseAPI {

    /**
     */
    async invitationApiControllerCreateInvitationRaw(requestParameters: InvitationApiControllerCreateInvitationRequest): Promise<runtime.ApiResponse<CreateInvitationResponse>> {
        if (requestParameters.createInvitationRequest === null || requestParameters.createInvitationRequest === undefined) {
            throw new runtime.RequiredError('createInvitationRequest','Required parameter requestParameters.createInvitationRequest was null or undefined when calling invitationApiControllerCreateInvitation.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/invitations`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createInvitationRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async invitationApiControllerCreateInvitation(requestParameters: InvitationApiControllerCreateInvitationRequest): Promise<CreateInvitationResponse> {
        const response = await this.invitationApiControllerCreateInvitationRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async invitationApiControllerEditInvitationRaw(requestParameters: InvitationApiControllerEditInvitationRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.invitationId === null || requestParameters.invitationId === undefined) {
            throw new runtime.RequiredError('invitationId','Required parameter requestParameters.invitationId was null or undefined when calling invitationApiControllerEditInvitation.');
        }

        if (requestParameters.editInvitationRequest === null || requestParameters.editInvitationRequest === undefined) {
            throw new runtime.RequiredError('editInvitationRequest','Required parameter requestParameters.editInvitationRequest was null or undefined when calling invitationApiControllerEditInvitation.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/invitations/{invitationId}`.replace(`{${"invitationId"}}`, encodeURIComponent(String(requestParameters.invitationId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.editInvitationRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async invitationApiControllerEditInvitation(requestParameters: InvitationApiControllerEditInvitationRequest): Promise<void> {
        await this.invitationApiControllerEditInvitationRaw(requestParameters);
    }

}
